
import { Button, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetRestaurant } from 'src/api/restaurant';
import Iconify from 'src/components/iconify/iconify';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import SubscriptionEdit from 'src/sections/restaurant/subscription-edit';



// ----------------------------------------------------------------------

export default function SubscriptionEditPage() {
    const params = useParams();
    const navigate = useNavigate()

    const { id, restaurantId } = params;

    const { restaurant } = useGetRestaurant(Number(restaurantId))
    return (
      <>
        <Helmet>
          <title> Dashboard: Subscription Edit</title>
        </Helmet>

        <Container maxWidth={false}>
          <Button
            size="small"
            variant="soft"
            component={RouterLink}
            onClick={() => navigate(-1)}
            startIcon={<Iconify icon="eva:arrow-ios-back-fill" width={16} />}
          >
            Back to Subscriptions List
          </Button>

          <br />
          <br />

          {restaurant?.name_en && (
            <Typography variant="h6" sx={{ mb: 5, textAlign: 'center' }}>
              {restaurant?.name_en}
            </Typography>
          )}

          <SubscriptionEdit id={id} restaurantId={Number(restaurantId)} />
        </Container>
      </>
    );
}
